// extracted by mini-css-extract-plugin
export var markdown = "_uw-0";
export var tableWrapper = "_uw-1";